export default [
    {
        comment: '',
        error_id: 'T-M-01',
        data: [
            {
                "cross_section": "42210",
                "target_mann_data": [
                    [
                        4712.4,
                        0.1
                    ],
                    [
                        4872.4,
                        0.15
                    ],
                    [
                        4985.4,
                        0.045
                    ],
                    [
                        5008.2,
                        0.15
                    ],
                    [
                        5171.1,
                        0.05
                    ],
                    [
                        5265.7,
                        0.06
                    ],
                    [
                        5347.4,
                        0.07
                    ]
                ],
                "mann_table": [
                    [
                        [
                            4712.4,
                            0.1
                        ],
                        [
                            4791.4,
                            0.15
                        ],
                        [
                            4985.4,
                            0.045
                        ],
                        [
                            5008.2,
                            0.15
                        ],
                        [
                            5171.1,
                            0.05
                        ],
                        [
                            5265.7,
                            0.06
                        ],
                        [
                            5347.4,
                            0.07
                        ]
                    ],
                    [
                        [
                            4712.4,
                            0.1
                        ],
                        [
                            4872.4,
                            0.15
                        ],
                        [
                            4985.4,
                            0.045
                        ],
                        [
                            5008.2,
                            0.15
                        ],
                        [
                            5171.1,
                            0.05
                        ],
                        [
                            5265.7,
                            0.06
                        ],
                        [
                            5347.4,
                            0.07
                        ]
                    ]
                ]
            },
            {
                "cross_section": "41697",
                "target_mann_data": [
                    [
                        4508.1,
                        0.11
                    ],
                    [
                        4539,
                        0.08
                    ],
                    [
                        4659.5,
                        0.05
                    ],
                    [
                        4759.9,
                        0.1
                    ],
                    [
                        4789.3,
                        0.15
                    ],
                    [
                        4970.1,
                        0.045
                    ],
                    [
                        5029,
                        0.15
                    ],
                    [
                        5371.8,
                        0.11
                    ],
                    [
                        "-",
                        "-"
                    ]
                ],
                "mann_table": [
                    [
                        [
                            4508.1,
                            0.11
                        ],
                        [
                            4539,
                            0.08
                        ],
                        [
                            4659.5,
                            0.05
                        ],
                        [
                            4759.9,
                            0.1
                        ],
                        [
                            4789.3,
                            0.15
                        ],
                        [
                            4970.1,
                            0.045
                        ],
                        [
                            5029,
                            0.15
                        ],
                        [
                            5371.8,
                            0.11
                        ],
                        [
                            5561.1,
                            0.09
                        ]
                    ],
                    [
                        [
                            4508.1,
                            0.11
                        ],
                        [
                            4539,
                            0.08
                        ],
                        [
                            4659.5,
                            0.05
                        ],
                        [
                            4759.9,
                            0.1
                        ],
                        [
                            4789.3,
                            0.15
                        ],
                        [
                            4970.1,
                            0.045
                        ],
                        [
                            5029,
                            0.15
                        ],
                        [
                            5371.8,
                            0.11
                        ],
                        [
                            "-",
                            "-"
                        ]
                    ]
                ]
            }
        ]
    },
    {
        error_id: 'T-M-ICS-01',
        data: [
            {
                "cross_section": "42210",
                "target_mann_data": [
                    [
                        4712.4,
                        0.1
                    ],
                    [
                        4872.4,
                        0.15
                    ],
                    [
                        4985.4,
                        0.045
                    ],
                    [
                        5008.2,
                        0.15
                    ],
                    [
                        5171.1,
                        0.05
                    ],
                    [
                        5265.7,
                        0.06
                    ],
                    [
                        5347.4,
                        0.07
                    ]
                ],
                "mann_table": [
                    [
                        [
                            4712.4,
                            0.1
                        ],
                        [
                            4791.4,
                            0.15
                        ],
                        [
                            4985.4,
                            0.045
                        ],
                        [
                            5008.2,
                            0.15
                        ],
                        [
                            5171.1,
                            0.05
                        ],
                        [
                            5265.7,
                            0.06
                        ],
                        [
                            5347.4,
                            0.07
                        ]
                    ],
                    [
                        [
                            4712.4,
                            0.1
                        ],
                        [
                            4872.4,
                            0.15
                        ],
                        [
                            4985.4,
                            0.045
                        ],
                        [
                            5008.2,
                            0.15
                        ],
                        [
                            5171.1,
                            0.05
                        ],
                        [
                            5265.7,
                            0.06
                        ],
                        [
                            5347.4,
                            0.07
                        ]
                    ]
                ]
            },
            {
                "cross_section": "41697",
                "target_mann_data": [
                    [
                        4508.1,
                        0.11
                    ],
                    [
                        4539,
                        0.08
                    ],
                    [
                        4659.5,
                        0.05
                    ],
                    [
                        4759.9,
                        0.1
                    ],
                    [
                        4789.3,
                        0.15
                    ],
                    [
                        4970.1,
                        0.045
                    ],
                    [
                        5029,
                        0.15
                    ],
                    [
                        5371.8,
                        0.11
                    ],
                    [
                        "-",
                        "-"
                    ]
                ],
                "mann_table": [
                    [
                        [
                            4508.1,
                            0.11
                        ],
                        [
                            4539,
                            0.08
                        ],
                        [
                            4659.5,
                            0.05
                        ],
                        [
                            4759.9,
                            0.1
                        ],
                        [
                            4789.3,
                            0.15
                        ],
                        [
                            4970.1,
                            0.045
                        ],
                        [
                            5029,
                            0.15
                        ],
                        [
                            5371.8,
                            0.11
                        ],
                        [
                            5561.1,
                            0.09
                        ]
                    ],
                    [
                        [
                            4508.1,
                            0.11
                        ],
                        [
                            4539,
                            0.08
                        ],
                        [
                            4659.5,
                            0.05
                        ],
                        [
                            4759.9,
                            0.1
                        ],
                        [
                            4789.3,
                            0.15
                        ],
                        [
                            4970.1,
                            0.045
                        ],
                        [
                            5029,
                            0.15
                        ],
                        [
                            5371.8,
                            0.11
                        ],
                        [
                            "-",
                            "-"
                        ]
                    ]
                ]
            }
        ]
    }
]